
// ******************
//
// Ver.1.0
// Released on: Nov 15, 2023
// Phase 1.5
//
// ******************
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TitlePopup from '@/components/common_new/popup/title.vue'
import ButtonCustom from '@/components/common_new/button-custom/index.vue'
import { ColumnsListMail } from '@/modules/provider/shared/constants'
import { ColumnsListMailAdditional } from '@/modules/provider/shared/constants'
import { isObject } from '@/shared/function'
import { filterStatusTable } from '@/shared/function'
import { listTypeMail } from '@/shared/constants'
import { DeleteFlg, RecieverFlg } from '@/shared/enums'
import { ListNamePopup } from '@/shared/enums'
import TooltipCustom from '@/components/common_new/tooltip/index.vue'

export default Vue.extend({
    name: 'MailListProvider',
    components: { TooltipCustom, ButtonCustom, TitlePopup },
    computed: {
        ...mapGetters('signupProvider', ['getDataListMail'])
    },
    data(): any {
        return {
            ColumnsListMail,
            ColumnsListMailAdditional,
            listMail: [],
            pageIndex: 1,
            listTypeMail,
            RecieverFlg
        }
    },
    mounted() {
        this.getListDataMail()
    },
    watch: {
        getDataListMail(newVal, oldVal) {
            if (newVal !== oldVal && isObject(newVal)) {
                this.listMail = newVal.map((item: any, index: number) => {
                    return {
                        id: item.id,
                        key: index,
                        type: item.type,
                        name: item.name,
                        email: item.email,
                        reciever_flg: item.reciever_flg === RecieverFlg.TRUE,
                        delete_flg: false
                    }
                })
            }
        }
    },
    methods: {
        filterStatusTable,
        onClosePopup() {
            this.$store.dispatch('popup/hidePopup')
        },
        getListDataMail() {
            this.$store.dispatch('signupProvider/getListMail', 0)
        },
        onChange(index: any, type: string) {
            switch (type) {
                case 'receiver':
                    this.listMail[index].reciever_flg =
                        !this.listMail[index].reciever_flg
                    break
                case 'receiver_add':
                    this.listMail[index].reciever_flg =
                        !this.listMail[index].reciever_flg
                    break
                case 'delete':
                    this.listMail[index].delete_flg =
                        !this.listMail[index].delete_flg
                    break
            }
        },
        async updateMailList() {
            let allData = [...this.listMail]
            let payload: {
                id: any
                reciever_flg: number
                delete_flg: number
            }[] = []
            allData.forEach((element, index) => {
                let dataPost = {
                    id: element.id,
                    reciever_flg: element.reciever_flg
                        ? RecieverFlg.TRUE
                        : RecieverFlg.FALSE,
                    delete_flg: element.delete_flg
                        ? DeleteFlg.TRUE
                        : DeleteFlg.FALSE
                }
                payload.push(dataPost)
            })
            await this.$store.dispatch(
                'signupProvider/updateListEmail',
                payload
            )
        },
        showPopupAddMail(payload: any) {
            this.$store.dispatch('popup/openPopup', {
                isOpen: true,
                namePopup: ListNamePopup.AddMailProvider,
                payload: payload
            })
        }
    }
})
